export default {
  SET_AUTH (state, token) {
    state.token = token
  },
  SET_USER (state, member) {
    state.user = member
  }
}
